export default {
  setFiles(state, payload) {
    state.files = payload;
  },
  setFilesCount(state, payload) {
    state.filesCount = payload;
  },
  setFileType(state, payload) {
    state.fileType = payload;
  },
  setLoading(state, isLoading) {
    state.loading = isLoading;
  },
  setCurrentPage(state, payload) {
    state.currentPage = payload;
  },
  setPerPage(state, payload) {
    state.perPage = payload;
  },
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-order/features/order-importer/store/mutations.js